<prlw-common-pane [appearance]="appearance">
  <a class="main-page-link" routerLink="/" aria-label="Главная страница">
    <img
      src="/assets/logo/{{ svgName || 'logo-en' }}.svg"
      aria-hidden="true"
      alt="{{ svgName || 'logo-en' }}"
    />
  </a>
</prlw-common-pane>
